/**
 * "Download the app" banner shown on public surfaces (e.g. the payment link
 * page) to convert one-off payers into app users. Links to the canonical
 * store listings and reports clicks to analytics; the current screen is
 * injected automatically by the analytics service.
 */

import { analyticsService } from '@meiuca/analytics'
import { Body, Caption } from '@meiuca/ui-components'
import { Download, Smartphone } from 'lucide-react'
import { ANALYTICS_EVENTS } from '@/constants/analyticsEvents'
import { APP_STORE_URL, PLAY_STORE_URL } from '@/constants/appStoreLinks'

const STORES = [
  { key: 'app_store', label: 'App Store', prefix: 'Download na', url: APP_STORE_URL, Icon: Smartphone },
  { key: 'google_play', label: 'Google Play', prefix: 'Baixar no', url: PLAY_STORE_URL, Icon: Download },
] as const

export function DownloadAppBanner() {
  return (
    <div className="rounded-2xl bg-background-white p-6 shadow-sm text-center space-y-4">
      <div className="space-y-1">
        <Body className="font-semibold text-text-primary">Baixe o aplicativo Meiuca</Body>
        <Caption className="text-text-secondary">
          Acompanhe seus pagamentos, reservas e treinos direto do celular.
        </Caption>
      </div>
      <div className="flex items-center justify-center gap-3 flex-wrap">
        {STORES.map(({ key, label, prefix, url, Icon }) => (
          <a
            key={key}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              analyticsService.track(ANALYTICS_EVENTS.DOWNLOAD_APP_BANNER_CLICKED, { store: key })
            }
            className="flex items-center gap-2 px-4 py-2 bg-background-secondary hover:bg-border-light rounded-lg transition-colors"
          >
            <Icon className="w-5 h-5 text-text-secondary" />
            <div className="text-left">
              <Caption className="text-text-tertiary text-xs">{prefix}</Caption>
              <Body className="text-text-primary text-sm font-semibold">{label}</Body>
            </div>
          </a>
        ))}
      </div>
    </div>
  )
}
